import { useNode } from '@craftjs/core';
import {
	SwitchControl,
	TextControl
} from 'pages/PageEditor/settingsComponents';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useMemo } from 'react';

const EditorTextareaSettings = () => {
	const {
		placeholder,
		label,
		fullWidth,
		required,
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [
		onPlaceholderChange,
		onLabelChange,
		onFullWidthChange,
		onRequiredChange
	] = useMemo(
		() =>
			['placeholder', 'label', 'fullWidth', 'required'].map((attr) =>
				generateOnChange(setProp, attr)
			),
		[setProp]
	);

	return (
		<div>
			<TextControl
				value={label}
				label={intl.tr('screenEditor.settings.input.label')}
				setValue={onLabelChange}
			/>

			<TextControl
				value={placeholder}
				label={intl.tr('screenEditor.settings.input.placeholder')}
				setValue={onPlaceholderChange}
			/>

			<SwitchControl
				value={fullWidth}
				label={intl.tr('screenEditor.settings.fullWidth')}
				setValue={onFullWidthChange}
			/>

			<SwitchControl
				value={required}
				label={intl.tr('screenEditor.settings.input.required')}
				setValue={onRequiredChange}
			/>
		</div>
	);
};

export { EditorTextareaSettings };
